import styled from 'styled-components';
import { doodles } from '../../styles/decor';

export const Fake = styled.div`
    background-color:#DDD;
    height:${props => props.height || 20}px;
`;

const SectionTag = `
    display:inline-flex;
    align-items:center;
    gap:8px;
    color:var(--salato-red);
    font-size:12px;
    font-weight:800;
    letter-spacing:.14em;
    text-transform:uppercase;
    margin-bottom:12px;

    &::before{
        content:'';
        width:18px;
        height:3px;
        border-radius:3px;
        background:var(--salato-yellow);
    }
`;

const SectionTitle = `
    margin:0;
    font-size:clamp(28px, 3.4vw, 44px);
    line-height:1.1;
    letter-spacing:-0.025em;
    color:var(--salato-ink);
    font-weight:800;
`;

/* ---------------- Hero + destaques ---------------- */
export const SearchArea = styled.section`
    position:relative;
    background:#fff;
    padding-bottom:64px;

    .hero{
        position:relative;
        overflow:hidden;
        isolation:isolate;

        &::before{
            content:'';
            position:absolute;
            inset:0;
            background-image:${doodles('#ec1c24', .07)};
            background-size:220px;
            -webkit-mask-image:linear-gradient(180deg, #000 0%, #000 55%, transparent 100%);
            mask-image:linear-gradient(180deg, #000 0%, #000 55%, transparent 100%);
            z-index:-1;
        }

    }

    .heroInner{
        max-width:1240px;
        margin:0 auto;
        position:relative;
        z-index:1;
        padding:24px 24px 110px;
        display:grid;
        grid-template-columns:minmax(0, 1.05fr) minmax(0, 1fr);
        align-items:center;
        gap:40px;
    }

    .heroText{
        animation:heroIn .8s var(--ease-out) both;
    }

    .heroTag{ ${SectionTag} }

    h1{
        margin:0;
        font-size:clamp(36px, 5vw, 64px);
        line-height:1.04;
        letter-spacing:-0.035em;
        color:var(--salato-ink);
        font-weight:800;

        em{
            font-style:normal;
            color:var(--salato-red);
        }
    }

    p{
        margin:22px 0 0;
        max-width:480px;
        font-size:18px;
        line-height:1.6;
        color:var(--salato-muted);
    }

    .heroActions{
        display:flex;
        flex-wrap:wrap;
        gap:12px;
        margin-top:32px;
    }

    .heroButton{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        height:54px;
        padding:0 26px;
        border-radius:999px;
        font-weight:700;
        font-size:15px;
        text-decoration:none;
        transition:transform .25s var(--ease-out), box-shadow .25s ease, background-color .2s ease;

        &:hover{ transform:translateY(-2px); }

        &.primary{
            background:var(--salato-red);
            color:#fff;
            box-shadow:0 12px 26px rgba(236, 28, 36, .30);

            &:hover{ box-shadow:0 16px 32px rgba(236, 28, 36, .36); }
        }

        &.secondary{
            background:#fff;
            color:var(--salato-ink);
            box-shadow:inset 0 0 0 1.5px var(--salato-line), var(--shadow-sm);

            &:hover{ box-shadow:inset 0 0 0 1.5px var(--salato-yellow), var(--shadow-md); }
        }
    }

    .heroMedia{
        position:relative;
        display:flex;
        align-items:center;
        justify-content:center;
        min-height:400px;
        animation:heroIn .9s var(--ease-out) .15s both;

        img{
            position:relative;
            z-index:1;
            width:min(100%, 580px);
            height:auto;
            filter:drop-shadow(0 30px 40px rgba(91, 33, 6, .22));
            transition:transform .6s var(--ease-out);
        }

        &:hover img{
            transform:rotate(-2deg) scale(1.02);
        }
    }

    .heroBlob{
        position:absolute;
        width:min(92%, 520px);
        aspect-ratio:1 / 1;
        border-radius:46% 54% 52% 48% / 52% 44% 56% 48%;
        background:linear-gradient(145deg, var(--salato-yellow) 0%, #ffb800 100%);
        opacity:.9;
        animation:blob 14s ease-in-out infinite alternate;
    }

    .heroHighlights{
        position:relative;
        z-index:2;
        max-width:1180px;
        margin:-72px auto 0;
        padding:0 24px;
        display:grid;
        grid-template-columns:repeat(4, minmax(0, 1fr));
        gap:16px;
    }

    .highlightCard{
        display:flex;
        align-items:flex-start;
        gap:14px;
        padding:22px;
        border-radius:var(--radius-md);
        background:var(--salato-red);
        box-shadow:0 14px 30px rgba(236, 28, 36, .28);
        transition:transform .3s var(--ease-out), box-shadow .3s ease;

        &:hover{
            transform:translateY(-4px);
            box-shadow:0 20px 40px rgba(236, 28, 36, .36);
        }

        strong{
            display:block;
            font-size:24px;
            line-height:1.1;
            color:#fff;
            font-weight:800;
        }

        span{
            display:block;
            margin-top:2px;
            font-size:15px;
            font-weight:700;
            color:#fff;
        }

        small{
            display:block;
            margin-top:4px;
            font-size:13px;
            color:var(--salato-yellow);
        }
    }

    .highlightIcon{
        flex-shrink:0;
        width:44px;
        height:44px;
        border-radius:14px;
        display:flex;
        align-items:center;
        justify-content:center;
        background:var(--salato-yellow);
        box-shadow:0 6px 14px rgba(255, 184, 0, .35);

        img{
            width:22px;
            height:22px;
            object-fit:contain;
            filter:brightness(0) saturate(100%) invert(17%) sepia(92%) saturate(5235%) hue-rotate(350deg) brightness(93%) contrast(97%);
        }
    }

    @keyframes heroIn{
        from{ opacity:0; transform:translate3d(0, 28px, 0); }
        to{ opacity:1; transform:none; }
    }

    @keyframes blob{
        0%{ border-radius:46% 54% 52% 48% / 52% 44% 56% 48%; transform:rotate(0deg); }
        100%{ border-radius:56% 44% 42% 58% / 44% 58% 42% 56%; transform:rotate(12deg); }
    }

    @media (max-width:980px){
        padding-bottom:48px;

        .heroInner{
            grid-template-columns:1fr;
            padding:20px 20px 100px;
            gap:12px;
            text-align:center;
        }

        .heroTag{ justify-content:center; }

        p{ margin-left:auto; margin-right:auto; }

        .heroActions{ justify-content:center; }

        .heroMedia{
            min-height:0;
            margin-top:8px;

            img{ width:min(80%, 420px); }
        }

        .heroBlob{ width:min(70%, 380px); }

        .heroHighlights{
            grid-template-columns:repeat(2, minmax(0, 1fr));
            gap:12px;
            padding:0 16px;
        }
    }

    @media (max-width:600px){
        .heroInner{ padding:16px 18px 90px; }

        p{ font-size:16px; }

        .heroButton{ flex:1 1 100%; }

        .highlightCard{
            flex-direction:column;
            gap:10px;
            padding:16px;

            strong{ font-size:20px; }
            span{ font-size:14px; }
            small{ font-size:12px; }
        }

        .highlightIcon{
            width:38px;
            height:38px;
            border-radius:12px;
        }
    }
`;

/* ---------------- Produtos ---------------- */
export const PageArea = styled.section`
    max-width:1240px;
    margin:0 auto;
    padding:80px 24px 88px;
    position:relative;
    isolation:isolate;

    &::before{
        content:'';
        position:absolute;
        top:0;
        bottom:0;
        left:50%;
        width:100vw;
        transform:translateX(-50%);
        display:none;
    }

    /* rabiscos por cima do degradê, sumindo nas bordas */
    &::after{
        content:'';
        position:absolute;
        top:0;
        bottom:0;
        left:50%;
        width:100vw;
        transform:translateX(-50%);
        background-image:${doodles('#ec1c24', .08)};
        background-size:220px;
        -webkit-mask-image:linear-gradient(180deg, transparent 0%, #000 22%, #000 78%, transparent 100%);
        mask-image:linear-gradient(180deg, transparent 0%, #000 22%, #000 78%, transparent 100%);
        z-index:-1;
        pointer-events:none;
    }

    .productsIntro,
    .productsGrid{
        position:relative;
        z-index:1;
    }

    .productsIntro{
        display:flex;
        align-items:flex-end;
        justify-content:space-between;
        gap:24px;
        margin-bottom:36px;

        .sectionTag{ ${SectionTag} }

        h2{ ${SectionTitle} max-width:560px; }

        p{
            margin:12px 0 0;
            max-width:520px;
            color:var(--salato-muted);
            font-size:17px;
            line-height:1.6;
        }
    }

    .productsButton{
        flex-shrink:0;
        display:inline-flex;
        align-items:center;
        gap:8px;
        height:48px;
        padding:0 22px;
        border-radius:999px;
        background:var(--salato-red);
        color:#fff;
        font-weight:700;
        font-size:15px;
        text-decoration:none;
        box-shadow:0 12px 26px rgba(236, 28, 36, .30);
        transition:transform .25s var(--ease-out), background-color .2s ease, box-shadow .25s ease;

        span{ transition:transform .25s var(--ease-out); }

        &:hover{
            background:var(--salato-red-strong);
            box-shadow:0 16px 32px rgba(236, 28, 36, .36);
            transform:translateY(-2px);

            span{ transform:translateX(4px); }
        }
    }

    .productsGrid{
        display:grid;
        grid-template-columns:repeat(4, minmax(0, 1fr));
        gap:20px;

        > div{ height:100%; }
    }

    .productCard{
        height:100%;
        display:flex;
        flex-direction:column;
        border-radius:var(--radius-lg);
        background:#fff;
        overflow:hidden;
        text-decoration:none;
        box-shadow:0 0 0 1px var(--salato-line), var(--shadow-sm);
        transition:transform .35s var(--ease-out), box-shadow .35s ease;

        &:hover{
            transform:translateY(-6px);
            box-shadow:0 0 0 1px transparent, var(--shadow-lg);

            .productImage img{ transform:scale(1.07); }
            .productMore span{ transform:translateX(4px); }
            .productMore{ color:var(--salato-red); }
        }
    }

    .productImage{
        position:relative;
        aspect-ratio:4 / 3;
        overflow:hidden;
        background:#f6efe9;

        img{
            width:100%;
            height:100%;
            object-fit:cover;
            display:block;
            transition:transform .6s var(--ease-out), opacity .5s ease;
        }
    }

    .productTag{
        position:absolute;
        left:12px;
        top:12px;
        padding:5px 10px;
        border-radius:999px;
        background:var(--salato-yellow);
        color:var(--salato-red-strong);
        box-shadow:0 4px 10px rgba(0,0,0,.12);
        font-size:11px;
        font-weight:800;
        letter-spacing:.02em;
    }

    .productInfo{
        flex:1;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        gap:10px;
        padding:16px 18px 18px;

        strong{
            color:var(--salato-ink);
            font-size:16px;
            line-height:1.35;
            font-weight:700;
        }
    }

    .productMore{
        display:inline-flex;
        align-items:center;
        gap:6px;
        color:var(--salato-muted);
        font-size:13px;
        font-weight:600;
        transition:color .2s ease;

        span{ transition:transform .25s var(--ease-out); }
    }

    @media (max-width:1100px){
        .productsGrid{ grid-template-columns:repeat(3, minmax(0, 1fr)); }
    }

    @media (max-width:800px){
        padding:64px 16px 72px;

        .productsIntro{
            flex-direction:column;
            align-items:flex-start;
        }

        .productsGrid{
            grid-template-columns:repeat(2, minmax(0, 1fr));
            gap:12px;
        }

        .productCard{ border-radius:18px; }

        .productInfo{
            padding:12px 12px 14px;

            strong{ font-size:14px; }
        }

        .productTag{
            left:8px;
            top:8px;
            font-size:10px;
            padding:4px 8px;
        }
    }
`;

/* ---------------- CTA, contato e localização ---------------- */
export const ContactArea = styled.section`
    padding:0 24px 96px;

    .sectionTag{ ${SectionTag} }

    .ctaBand{
        max-width:1192px;
        margin:0 auto 96px;
        padding:40px 44px;
        border-radius:28px;
        background:
            radial-gradient(500px 240px at 100% 0%, rgba(255, 214, 10, .35), transparent 70%),
            ${doodles('#ffd60a', .22)} 0 0 / 200px,
            var(--salato-red);
        color:#fff;
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:24px;
        box-shadow:0 24px 50px rgba(236, 28, 36, .25);

        h2{
            margin:0;
            font-size:clamp(24px, 2.8vw, 36px);
            line-height:1.15;
            letter-spacing:-0.02em;
            font-weight:800;
        }

        p{
            margin:10px 0 0;
            font-size:16px;
            color:rgba(255,255,255,.88);
        }
    }

    .ctaActions{
        display:flex;
        flex-wrap:wrap;
        gap:12px;
        flex-shrink:0;
    }

    .ctaWhats,
    .ctaGhost{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        gap:10px;
        height:52px;
        padding:0 22px;
        border-radius:999px;
        font-weight:700;
        font-size:15px;
        text-decoration:none;
        transition:transform .25s var(--ease-out), background-color .2s ease;

        &:hover{ transform:translateY(-2px); }
    }

    .ctaWhats{
        background:#fff;
        color:#128c4a;

        img{ width:22px; height:22px; }
    }

    .ctaGhost{
        color:#fff;
        box-shadow:inset 0 0 0 1.5px rgba(255,255,255,.6);

        &:hover{ background:rgba(255,255,255,.12); }
    }

    .contactHeading,
    .locationHeading{
        max-width:720px;
        margin:0 auto 40px;
        text-align:center;

        .sectionTag{ justify-content:center; }

        h2{ ${SectionTitle} }

        p{
            margin:14px 0 0;
            color:var(--salato-muted);
            font-size:17px;
            line-height:1.6;
        }
    }

    .contactVisual{
        max-width:1100px;
        margin:0 auto;
        display:grid;
        grid-template-columns:minmax(0, 1.25fr) minmax(0, 1fr);
        align-items:center;
    }

    .contactImageWrap{
        height:440px;
        border-radius:28px;
        overflow:hidden;
        box-shadow:var(--shadow-lg);

        img{
            width:100%;
            height:100%;
            object-fit:cover;
            display:block;
        }
    }

    .contactCard{
        position:relative;
        margin-left:-72px;
        padding:30px 26px;
        border-radius:28px;
        background:#fff;
        box-shadow:var(--shadow-lg);
        display:flex;
        flex-direction:column;
        gap:6px;
    }

    .contactCardTitle{
        display:block;
        margin:0 8px 10px;
        font-size:20px;
        font-weight:800;
        color:var(--salato-ink);
    }

    .contactItem{
        display:flex;
        align-items:center;
        gap:14px;
        padding:10px;
        border-radius:16px;
        text-decoration:none;
        color:inherit;
        transition:background-color .2s ease;

        &:hover{
            background:var(--salato-red-soft);

            .contactArrow{
                opacity:1;
                transform:translateX(0);
            }
        }
    }

    .contactIcon{
        flex-shrink:0;
        width:46px;
        height:46px;
        border-radius:14px;
        display:flex;
        align-items:center;
        justify-content:center;
        background:var(--salato-red-soft);

        img{
            width:26px;
            height:26px;
            object-fit:contain;

            &.whiteIcon{
                filter:brightness(0) saturate(100%) invert(17%) sepia(92%) saturate(5235%) hue-rotate(350deg) brightness(93%) contrast(97%);
            }
        }
    }

    .contactText{
        flex:1;
        min-width:0;
        display:flex;
        flex-direction:column;

        strong{
            font-size:13px;
            font-weight:600;
            color:var(--salato-muted);
        }

        span{
            font-size:16px;
            font-weight:700;
            color:var(--salato-ink);
            overflow-wrap:anywhere;
        }
    }

    .contactArrow{
        color:var(--salato-red);
        font-weight:700;
        opacity:0;
        transform:translateX(-6px);
        transition:opacity .2s ease, transform .25s var(--ease-out);
    }

    .contactBlock{ margin-top:96px; }

    .partnersSection{
        max-width:1240px;
        margin:0 auto;
    }

    .partnersHeading{
        max-width:640px;
        margin:0 auto 36px;
        text-align:center;

        .sectionTag{ justify-content:center; }

        h2{ ${SectionTitle} }

        p{
            margin:14px 0 0;
            color:var(--salato-muted);
            font-size:17px;
            line-height:1.6;
        }
    }

    .partnersMarquee{
        position:relative;
        overflow:hidden;
        padding:12px 0 20px;
        -webkit-mask-image:linear-gradient(90deg, transparent 0%, #000 8%, #000 92%, transparent 100%);
        mask-image:linear-gradient(90deg, transparent 0%, #000 8%, #000 92%, transparent 100%);

        &:hover .partnersTrack{ animation-play-state:paused; }
    }

    .partnersTrack{
        display:flex;
        width:max-content;
        animation:partnersScroll 80s linear infinite;
    }

    .partnerCard{
        flex-shrink:0;
        margin-right:20px;
        width:170px;
        height:170px;
        border-radius:24px;
        overflow:hidden;
        background:#fff;
        box-shadow:0 0 0 1px var(--salato-line), var(--shadow-sm);
        transition:transform .35s var(--ease-out), box-shadow .35s ease;

        img{
            width:100%;
            height:100%;
            object-fit:cover;
            display:block;
        }

        &:hover{
            transform:translateY(-6px) rotate(-1.5deg);
            box-shadow:0 0 0 1px transparent, var(--shadow-lg);
        }
    }

    @keyframes partnersScroll{
        from{ transform:translate3d(0, 0, 0); }
        to{ transform:translate3d(-50%, 0, 0); }
    }

    @media (prefers-reduced-motion: reduce){
        .partnersMarquee{
            -webkit-mask-image:none;
            mask-image:none;
        }

        .partnersTrack{
            width:auto;
            gap:14px;
            flex-wrap:wrap;
            justify-content:center;
            animation:none;
        }

        .partnerCard[aria-hidden='true']{ display:none; }
    }

    .clientsMapSection{
        max-width:1100px;
        margin:96px auto 0;

        .sectionLead{
            max-width:560px;
            margin:12px auto 0;
            color:var(--salato-muted);
            font-size:17px;
        }
    }

    .locationSection{
        position:relative;
        max-width:1100px;
        margin:96px auto 0;
        padding:72px 0 8px;
        isolation:isolate;

        &::before{
            content:'';
            position:absolute;
            top:0;
            bottom:-96px;
            left:50%;
            width:100vw;
            transform:translateX(-50%);
            background-image:${doodles('#ec1c24', .07)};
            background-size:220px;
            -webkit-mask-image:linear-gradient(180deg, transparent 0%, #000 25%, #000 75%, transparent 100%);
            mask-image:linear-gradient(180deg, transparent 0%, #000 25%, #000 75%, transparent 100%);
            z-index:-1;
        }
    }

    .locationCard{
        display:grid;
        grid-template-columns:minmax(0, .9fr) minmax(0, 1.3fr);
        gap:8px;
        padding:8px;
        border-radius:28px;
        background:#fff;
        box-shadow:0 0 0 1px var(--salato-line), var(--shadow-md);
    }

    .locationInfo{
        display:flex;
        flex-direction:column;
        justify-content:center;
        gap:14px;
        padding:32px;

        strong{
            font-family:'bariol-bold-webfont','Inter',sans-serif;
            font-size:clamp(26px, 2.6vw, 34px);
            line-height:1.1;
            color:var(--salato-red);
        }

        p{
            margin:0;
            color:var(--salato-ink);
            font-size:18px;
            line-height:1.5;
        }
    }

    .locationLink{
        align-self:flex-start;
        display:inline-flex;
        align-items:center;
        gap:8px;
        margin-top:8px;
        height:46px;
        padding:0 20px;
        border-radius:999px;
        background:var(--salato-red);
        color:#fff;
        font-weight:700;
        font-size:14px;
        text-decoration:none;
        transition:transform .25s var(--ease-out), background-color .2s ease;

        &:hover{
            background:var(--salato-red-strong);
            transform:translateY(-2px);
        }
    }

    .locationMapWrap{
        min-height:340px;
        border-radius:22px;
        overflow:hidden;
        background:#f3eee9;

        iframe{
            width:100%;
            height:100%;
            min-height:340px;
            border:0;
            display:block;
        }
    }

    @media (max-width:980px){
        padding:0 16px 72px;

        .ctaBand{
            flex-direction:column;
            align-items:flex-start;
            padding:28px 24px;
            margin-bottom:72px;
        }

        .contactVisual{ grid-template-columns:1fr; }

        .contactImageWrap{ height:260px; }

        .contactCard{
            margin:-48px 12px 0;
            padding:22px 16px;
        }

        .contactArrow{
            opacity:1;
            transform:none;
        }

        .locationSection{ margin-top:72px; }

        .clientsMapSection{
            margin-top:72px;
            padding:0 16px;

            .sectionLead{ font-size:16px; }
        }

        .contactBlock{ margin-top:72px; }

        .partnerCard{
            width:128px;
            height:128px;
            border-radius:18px;
        }

        .partnerCard{ margin-right:14px; }

        .locationCard{ grid-template-columns:1fr; }

        .locationInfo{ padding:20px 16px 12px; }

        .locationMapWrap,
        .locationMapWrap iframe{ min-height:260px; }
    }

    @media (max-width:600px){
        .ctaActions{ width:100%; }

        .ctaWhats,
        .ctaGhost{ flex:1 1 100%; }

        .contactHeading p{ font-size:16px; }
    }
`;
